export const allContentLanguages = [
	"ENGLISH",
	"FRENCH",
	"WOLOF",
	"SERERE",
	"PULAAR",
	"DJOLEA",
	"BAMBARA",
	"SONINKE",
	"BAOULE",
	"BETE",
	"SENOUFO",
	"DIOULA",
	"NOUCHI",
] as const;

export type ContentLanguage = (typeof allContentLanguages)[number];
